<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Búsqueda avanzada</h1>
</div>

<!--&================= CONTAINER BAR NAVIGATION =================&-->

<div class="Options-Menu">

  <!---================= CONTAINER SELECT TYPE Finance =================--->
  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <button (click)="Search_Validate()" class="Local-Icon-Card button-square">
        <i class="fa-solid fa-magnifying-glass"></i>
      </button>
    </div>

    <div class="Container-Card Search-file">

      <div class="Input-Option Search-file">
        <div class="search inputText"><input [(ngModel)]="Input_Search" (keypress)="Search_Enter($event)" type="text"
            placeholder="Buscar documento" />
        </div>

      </div>

    </div>
  </div>

  <!---================= CONTAINER SELECT TYPE Finance =================--->
  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-file-contract"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Tipo de Documento</h2>
      </div>

      <div class="Input-Option Container-Select-Type">
        <div class="Container-input Inputng-Select">
          <i class="fa-regular fa-circle-question"></i>
          <ng-select [searchable]="false" bindLabel="Name" [items]="Option_Type_File"
            [(ngModel)]="Select_Option_Type_File">
          </ng-select>
          <i class="fa-solid fa-angle-down"></i>
        </div>

      </div>

    </div>
  </div>

  <!---================= CONTAINER SELECT TYPE Finance =================--->
  <div class="Card-Option container-global-components">

    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-book"></i>
      </div>
    </div>

    <div class="Container-Card">

      <div class="Option-Title">
        <h2>Librería</h2>
      </div>

      <div class="Input-Option Container-Select-Type">
        <div class="Container-input Inputng-Select">
          <i class="fa-regular fa-circle-question"></i>
          <ng-select [searchable]="false" bindLabel="Name" [items]="Option_Type_Library"
            [(ngModel)]="Select_Option_Type_Libr">
          </ng-select>
          <i class="fa-solid fa-angle-down"></i>
        </div>

      </div>

    </div>
  </div>
  <!---=-================= INPUT BUSQUEDA POR CONTENIDO (IA) ==================-=--->
  <div class="Card-Option container-global-components card-content-search" [class.active-content]="Input_Content_Search.length > 0">

    <div class="Icon-Left">
      <button (click)="Search_Validate_Content()" class="Local-Icon-Card button-square" title="Buscar en contenido del archivo">
        <i class="fa-solid fa-brain"></i>
      </button>
    </div>

    <div class="Container-Card Search-file">
      <div class="Input-Option Search-file content-input-wrap">
        <div class="search inputText">
          <input
            [(ngModel)]="Input_Content_Search"
            (keypress)="Search_Enter_Content($event)"
            type="text"
            placeholder="Buscar en contenido del archivo..."
          />
        </div>
      </div>
    </div>

  </div>

</div>

<div class="Container-Search-Files">
  <ng-container *ngIf="!IsSearch && !LoadPage">

    <div class="Not-Files container-global-components">
      <div class="Img-Not">
        <img src="./assets/Global/Ilustrations/Search.png" alt="">
      </div>
      <div class="Text-Not-Files">
        Escriba en el nombre del documento que desea buscar.
      </div>
    </div>

  </ng-container>

  <ng-container *ngIf="IsSearch && LoadPage && Files_Search.length > 0">
    <div class="File-List container-global-components">

      <p-table #dt [value]="Files_Search" dataKey="id" [rowHover]="true" [rows]="5" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[5,10,15,25, 50]" [paginator]="true"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" [filterDelay]="0"
        [globalFilterFields]="['Name','Purpose','Code','Revision_No','Approver1_Name','Approver2_Name','Approver3_Name','Approver4_Name','Contributor_Name']">


        <!---================= SEARCH AND ALL FIN =================--->
        <ng-template pTemplate="caption">

          <div class="SectionCreateTotal Table_NG">
            <div class="left-CT">
            </div>
            <div class="right-CT">

              <!--?===== INFO OF TOTAL FIN =====?-->
              <div class="AllFiles">Total de documentos encontrados:
                <b>{{this.Files_Search.length}}</b><i class="fas fa-file"></i>
              </div>
            </div>
          </div>

        </ng-template>


        <ng-template pTemplate="header">
          <tr>

            <th></th>

          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-Files_Search>

          <tr>

            <td class="List-Card-Container" (click)="Asign_Document(Files_Search)">


              <ng-container *ngFor="let icon of Icons_Image">

                <div class="Card-Find" *ngIf="Files_Search.Extension.toUpperCase()==icon.Extension.toUpperCase()">
                  <div class="Icon">
                    <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                  </div>
                  <div class="Content-Info">
                    <div class="Name" (click)="GoToLocationDirect(Files_Search, $event)"
                      title="Ir a ubicación del archivo">
                      {{Files_Search.Name}}
                    </div>
                    <div class="Path">
                      {{Clean_Route(Files_Search.Path)}}
                    </div>
                  </div>
                </div>

              </ng-container>
            </td>

          </tr>

        </ng-template>

      </p-table>
    </div>
  </ng-container>

  <ng-container *ngIf="IsSearch && LoadPage && Files_Search.length === 0">
    <div class="Not-Files container-global-components">
      <div class="Img-Not">
        <img src="./assets/Global/Ilustrations/No-Find.png" alt="">
      </div>
      <div class="Text-Not-Files">
        No se encontró ningún documento con
        <span *ngIf="!SearchContent">el nombre <b>{{Input_Search}}</b></span>
        <span *ngIf="SearchContent">el contenido <b>{{Input_Content_Search}}</b></span>
      </div>
    </div>
  </ng-container>



  <div class="Card-File container-global-components Max-Height">

    <ng-container *ngIf="!SeeCard">
      <div class="Not-Files ">
        <div class="Img-Not Card">
          <img src="./assets/Global/Ilustrations/Search.png" alt="">
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="SeeCard">
      <div class="Top">
        <div class="Section-Text">
          <div class="Title">
            Nombre
          </div>
          <div class="Description">
            {{Document_Selected.Name}}
          </div>
        </div>
        <div class="Section-Text">
          <div class="Title">
            Extensión
          </div>
          <div class="Description">
            {{Document_Selected.Extension}}
          </div>
        </div>
        <div class="Section-Text">
          <div class="Title">
            Estatus
          </div>
          <div class="Description">
            {{Status_string(Document_Selected.Status)}}
          </div>
        </div>
      </div>

      <div class="Middle">
        <div class="Section-Text">
          <div class="Title">
            Contribuidor
          </div>
          <div class="Description">
            {{Document_Selected.Contributor_Name}}
          </div>
        </div>
        <div class="Section-Text">
          <div class="Title">
            Fecha de carga
          </div>
          <div class="Description">
            {{ Get_Date_Created(Document_Selected.Date_Created)}}
          </div>
        </div>
        <div class="Section-Text">
          <div class="Title">
            Fecha de vencimiento
          </div>
          <div class="Description">
            {{Get_Date_Expiration(Document_Selected.Date_Expiration)}}
          </div>
        </div>

        <div class="Section-Text">
          <div class="Title">
            Librería
          </div>
          <div class="Description">
            {{Library_String(Document_Selected.Library)}}
          </div>
        </div>

      </div>

      <div class="Bottom">
        <button (click)="SeeFINLibrary()" class="btn-icon-text-left">
          <span class="text">Ubicación Archivo</span><i class="fa-solid fa-paper-plane"></i>
        </button>
      </div>
    </ng-container>
  </div>


</div>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
